import { createFileRoute } from "@tanstack/react-router";
import { ProveedorManualPage } from "@/features/proveedor-manual/components/ProveedorManualPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/proveedor-manual` · P44 FB60 Contrapago.
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/proveedor-manual")({
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: ProveedorManualPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
